import React from 'react';

const reasons = [
  {
    emoji: '🎨',
    title: 'One-of-a-Kind',
    desc: 'Every design is generated uniquely from your words. No two are ever the same.',
  },
  {
    emoji: '❤️',
    title: 'Deeply Personal',
    desc: "Create something that reflects who they are — their style, passions, or inside jokes.",
  },
  {
    emoji: '⚡',
    title: 'Ready in Minutes',
    desc: 'From idea to ordered gift in under 2 minutes. Perfect for last-minute moments.',
  },
  {
    emoji: '🌍',
    title: 'Ships Worldwide',
    desc: 'Printed on premium products and delivered anywhere in the world.',
  },
];

function GiftSection() {
  return (
    <section className="gift-section">
      <div className="gift-section-inner">
        <div className="gift-section-label">🎁 Perfect Gift Idea</div>
        <h2 className="section-title">The Most Unique Gift<br />They'll Ever Receive</h2>
        <p className="section-subtitle">
          Forget generic gifts. Give something made just for them — by you, powered by AI.
        </p>
        <div className="gift-reasons">
          {reasons.map((r) => (
            <div key={r.title} className="gift-reason-card">
              <div className="gift-reason-icon">{r.emoji}</div>
              <h4>{r.title}</h4>
              <p>{r.desc}</p>
            </div>
          ))}
        </div>
        <a href="#create" className="gift-cta-btn">
          ✨ Create a Gift Now
        </a>
      </div>
    </section>
  );
}

export default GiftSection;
